export default __webpack_public_path__ + "static/sampoerna-bg2-0821ce73fe5c490e81233aa4662bf64a.png";